import React, { useRef } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { PlusIcon } from '@fiverr-private/visuals';
import { appTranslate } from '../../i18n';
import { useCvMatch } from '../../lib/cvMatch';
import { useBI } from '../../bi';

const ACCEPT = '.pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const UploadCv = () => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { status, error, submit } = useCvMatch();
    const bi = useBI();

    const busy = status === 'parsing' || status === 'matching';

    const openPicker = () => {
        if (busy) {
            return;
        }
        inputRef.current?.click();
    };

    return (
        <Stack direction="column" gap="2">
            <Stack
                direction={{ default: 'column', xl: 'row' }}
                alignItems={{ default: 'flexStart', xl: 'center' }}
                gap="4"
            >
                <Typography
                    as="span"
                    color="black"
                    fontWeight="light"
                    size={{ default: 'b_xl', lg: 'h_lg' }}
                    letterSpacing="-0.06em"
                >
                    {appTranslate('open_positions.ai_match')}
                </Typography>
                <Stack
                    as="span"
                    direction="row"
                    alignItems="center"
                    gap="2"
                    role="button"
                    tabIndex={0}
                    aria-disabled={busy}
                    cursor={busy ? 'wait' : 'pointer'}
                    opacity={busy ? '0.6' : '1'}
                    backgroundColor="black"
                    paddingX="5"
                    paddingY="2"
                    onClick={openPicker}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openPicker()}
                    style={{ borderRadius: 9999 }}
                >
                    <input
                        ref={inputRef}
                        type="file"
                        accept={ACCEPT}
                        hidden
                        onChange={(e) => {
                            if (e.target.files?.[0]) {
                                bi.reportCvUploadStart({ source: 'picker' });
                                void submit(e.target.files[0]);
                            }
                        }}
                    />
                    <Typography as="span" color="white" size="b_sm" fontWeight="bold" whiteSpace="nowrap">
                        {busy
                            ? appTranslate(status === 'parsing' ? 'cv_match.parsing' : 'cv_match.matching')
                            : appTranslate('open_positions.upload_cv')}
                    </Typography>
                    {!busy && <PlusIcon size="sm" color="white" />}
                </Stack>
            </Stack>
            {status === 'error' && (
                <Typography as="p" color="validationErrorDark" size="b_sm">
                    {error}
                </Typography>
            )}
        </Stack>
    );
};
